import React, { useEffect, useState } from "react";
import { LoaderComponent } from "@iiht/components";
import { useDispatch, useSelector } from "react-redux";
import { localStorageHelper, getPaginationParams } from "../../utils";
import { getResourcePermissions, getUserNotificationListData } from "../../store/actions";

const withRBAC = (WrappedComponent) => {
  return () => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);

    if (!localStorageHelper.get("accessToken") && !isLoading) {
      setIsLoading(true);
    }

    // Make API call for resource permissions
    const sideNavMenu = useSelector((state) => state?.rbacManagement?.resourceList);
    const { resourceListError } = useSelector((state) => state?.rbacManagement);

    useEffect(() => {
      localStorageHelper.set("isTokenRefreshed", false);
    }, []);

    useEffect(() => {
      if (localStorageHelper.get("accessToken") && sideNavMenu?.length === 0) {
        dispatch(
          getResourcePermissions({
            roles: JSON.parse(localStorageHelper.get("role_name")),
            tenant_id: localStorageHelper.get("localTenantId")
          })
        );
        dispatch(getUserNotificationListData(getPaginationParams(6, 1, "-created_at")));
      } else if (sideNavMenu?.length > 0) {
        setIsLoading(true);
      }
    }, [sideNavMenu, dispatch]);

    useEffect(() => {
      if (resourceListError) {
        console.log(resourceListError);
        setIsLoading(true);
      }
    }, [resourceListError]);
    return isLoading ? <WrappedComponent /> : <LoaderComponent spinning={true} isBackdrop={true} />;
  };
};

export default withRBAC;
